/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Handoff_LabelInputs */

const bn_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হ্যান্ডঅফ`)
};

const de_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WEITERLEITEN`)
};

const el_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HANDOFF`)
};

const en_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HANDOFF`)
};

const es_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MANOS LIBRES`)
};

const fr_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RELAIS`)
};

const hi_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सौंपना`)
};

const hu_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KIADÁS`)
};

const id_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PENYERAHAN`)
};

const it_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GIÙ LE MANI`)
};

const ja_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渡す`)
};

const ko_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핸드오프`)
};

const nl_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OVERDRACHT`)
};

const pl_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRZEKAZANIE`)
};

const pt_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÃO INTERFERIR`)
};

const ru_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПЕРЕДАВАТЬ`)
};

const sv_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HANDOFF`)
};

const tr_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOKUNMA`)
};

const uk_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПЕРЕДАЧА`)
};

const vi_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TUYỆT VỜI`)
};

const zh_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可触摸`)
};

const zh_hant_cipher_transition_handoff_label = /** @type {(inputs: Cipher_Transition_Handoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可觸摸`)
};

/**
* | output |
* | --- |
* | "HANDOFF" |
*
* @param {Cipher_Transition_Handoff_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_handoff_label = /** @type {((inputs?: Cipher_Transition_Handoff_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Handoff_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_handoff_label(inputs)
	if (locale === "de") return de_cipher_transition_handoff_label(inputs)
	if (locale === "el") return el_cipher_transition_handoff_label(inputs)
	if (locale === "en") return en_cipher_transition_handoff_label(inputs)
	if (locale === "es") return es_cipher_transition_handoff_label(inputs)
	if (locale === "fr") return fr_cipher_transition_handoff_label(inputs)
	if (locale === "hi") return hi_cipher_transition_handoff_label(inputs)
	if (locale === "hu") return hu_cipher_transition_handoff_label(inputs)
	if (locale === "id") return id_cipher_transition_handoff_label(inputs)
	if (locale === "it") return it_cipher_transition_handoff_label(inputs)
	if (locale === "ja") return ja_cipher_transition_handoff_label(inputs)
	if (locale === "ko") return ko_cipher_transition_handoff_label(inputs)
	if (locale === "nl") return nl_cipher_transition_handoff_label(inputs)
	if (locale === "pl") return pl_cipher_transition_handoff_label(inputs)
	if (locale === "pt") return pt_cipher_transition_handoff_label(inputs)
	if (locale === "ru") return ru_cipher_transition_handoff_label(inputs)
	if (locale === "sv") return sv_cipher_transition_handoff_label(inputs)
	if (locale === "tr") return tr_cipher_transition_handoff_label(inputs)
	if (locale === "uk") return uk_cipher_transition_handoff_label(inputs)
	if (locale === "vi") return vi_cipher_transition_handoff_label(inputs)
	if (locale === "zh") return zh_cipher_transition_handoff_label(inputs)
	return zh_hant_cipher_transition_handoff_label(inputs)
});